<template>
  <div>
    <template v-for="(item, index) in options">
      <template v-if="value===item.type">
        <a-tag
          :color="getColor(index)"
          :index="index">
          {{ item.name }}
        </a-tag>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BooleanDictTag',
  props: {
    options: {
      type: Array,
      default: null
    },
    value: {
      type: [Boolean],
      default: null
    }
  },
  data() {
    return {
      tag_bg: ['green', 'red', 'bg3', 'bg4', 'bg5']
    }
  },
  methods: {
    getColor(index) {
      return this.tag_bg[index]
    }
  },
  computed: {
    values() {
      return this.value
    }
  }
}
</script>
